import _intersection from 'lodash/intersection';
import { AuthTypes, Entitlements } from 'enums';

/**
 * Verifies if the user's authenticated entitlements contain the Exectuive entitlement.
 * @param {array} userAuth - array of entitlements
 * @returns {boolean}
 */
export function isEspnPlusExecAccount(userAuth = []) {
    return !!userAuth.length && (userAuth.indexOf(Entitlements.ESPN_EXEC) !== -1);
}

/**
 * Verifies if the user's authenticated entitlements contain TDA entitlement.
 * @param {array} userAuth - array of entitlements
 * @returns {boolean}
 */
export function isEspnPlusTDA(userAuth = []) {
    return !!userAuth.length && (userAuth.indexOf(Entitlements.ESPN_TDA) !== -1);
}

export function checkESPNPlusAuthentication(stream = {}, userAuth = []) {
    const { authTypes, packages = [] } = stream;
    if (authTypes.indexOf(AuthTypes.BAM) === -1) {
        return false;
    }

    if (packages.length === 0) {
        return true;
    }

    const userAuthForESPNPlus = userAuth
        .filter(auth => auth.indexOf(AuthTypes.MVPD) === -1 && auth.indexOf(AuthTypes.ISP) === -1);

    // NOTE: For `Executive` accounts we always allow access to all content
    if (isEspnPlusExecAccount(userAuth)) {
        return true;
    }

    // For TDA accounts, allow access to all content
    if (isEspnPlusTDA(userAuth)) {
        return true;
    }

    if (packages.length === 1 && userAuthForESPNPlus.indexOf(packages[0]) > -1) {
        return true;
    }

    if (_intersection(packages, userAuthForESPNPlus).length > 0) {
        return true;
    }

    return false;
}
/**
 * Checks a user's authentication status for a given content based on what is available in state.
 * It is shallow because it doesn't fetch any additional data, just calculates based on what we have already.
 *
 * @param {array} authTypes - Destructured from content object.  The authTypes required to watch this content
 * @param {array} userAuth - The authTypes a user has at this given moment
 * @param {boolean} optimistic - Returns true if a user's authTypes are currently unknown
 */

export default function shallowCheckAuthentication(stream = {}, userAuth = [], optimisitic = true) {
    const { authTypes, source = '' } = stream;
    // if a content does not have authTypes, it's available for everyone
    if (!authTypes || authTypes.length === 0 || authTypes.some(authType => authType === AuthTypes.OPEN)) {
        return true;
    }

    // E+ content in legacy app
    if (authTypes.indexOf(AuthTypes.MVPD) > -1 && source === 'ESPN+') {
        return false;
    }

    // check if a user's authTypes intersects with a content's authTypes
    if (userAuth && authTypes) {
        const ESPNPlusAuthentication = checkESPNPlusAuthentication(stream, userAuth);

        return ESPNPlusAuthentication || (authTypes.some(authType => userAuth.indexOf(authType) !== -1 ||
            (userAuth.indexOf(`unknown_${authType}`) !== -1 && optimisitic)));
    }

    // if we got here, we didn't have all the information to shallow check auth
    return optimisitic;
};



// WEBPACK FOOTER //
// ./app/lib/auth/shallowCheckAuthentication.js